<template>
  <div class="hero">
    <div class="graphic-frame">
      <img alt="AR|VR graphic. Reflections of Reality." src="../assets/ar-vr-reflect.png" />
    </div>
    <h1>Ben Drechsel</h1>
    <h2>⸺ UX Design Engineer ⸺</h2>
    <a class="image-button" href="https://www.linkedin.com/in/bendrechsel/">
      <img src="../assets/in-box.png" alt="Link to LinkedIn Profile" />
    </a>
    <a class="image-button" href="https://twitter.com/bendrexl">
      <img src="../assets/twitter-box.png" alt="Link to Twitter Profile" />
    </a>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    msg: String
  }
};
</script>

<style lang="scss">
@import "@/global-styles/colors.scss";
@import "@/global-styles/typography.scss";

h1,
h2 {
  font-family: $headings-font-family;
  background: linear-gradient(#3260b7 0%, #76aece 100%);
  // eslint-disable-next-line
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

h1 {
  margin: 0;
  font-size: 58px;
  line-height: 58px;
  font-weight: 300;
}

h2 {
  font-style: normal;
  font-weight: normal;
  //   font-size: 36px;
  font-size: 26px;
  //   margin: 10px 0;
  margin: 0;
}

div.graphic-frame {
  padding: 70px 0;
  img {
    width: 172px;
    height: 248px;
  }
}

a.image-button {
  outline: none;
  img {
    width: 25px;
    margin: 14px 5px;
  }
}
</style>
